import { createContext } from 'react';
export const NextLevelContext = createContext(null);